import { AdditiveBlending, Color, MultiplyBlending, RawShaderMaterial, SubtractiveBlending, Vector2 } from 'three'
import VS from './shaders/simple-vs.glsl'
import FS from './shaders/coin-bg-fs.glsl'
export default {
  getMaterial() {
    const material = new RawShaderMaterial({
      transparent: true,
      uniforms: {
        time: { value: 0 },
        color1: { value: new Color(0xffffff) },
        color2: { value: new Color(0xffffff) },
        opacity: { value: 0 }
      },
      depthTest: true,
      depthWrite: true,
      vertexShader: VS,
      fragmentShader: FS
    })

    return material
  }
}
